// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"865":"a5c72502","916":"c1884af3"}[chunkId] + ".chunk.css";
};